import { createSelector } from '@reduxjs/toolkit';
import { selectActiveVariantId } from '@ff-scene-plugins/gift-redux/selectors/variantSelectors';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { applyPrefab, selectActivePrefab, selectFilteredPrefabs } from '../_redux-prefabs';
import { selectContentFirst, selectIfPrefabsFitAllVariants } from '../_redux-scene';

export const applyDefaultPrefabForActiveVariant = (dispatch: GiftPdpDispatch, getState: () => GiftPdpState) => {
    const state = getState();

    // In content-first mode, don't reset the prefab when variant changes
    const isContentFirst = selectContentFirst(state);

    if (isContentFirst) {
        // Check if current prefab is still valid for the new variant
        const activePrefab = selectActivePrefab(state);
        const filteredPrefabs = selectFilteredPrefabs(state);
        const currentPrefabStillValid = activePrefab && filteredPrefabs.some(p => p.id === activePrefab.id);

        // Only apply default if current prefab is excluded from this variant
        if (!currentPrefabStillValid) {
            const defaultPrefabForVariant = selectDefaultPrefabForActiveVariant(state);
            if (defaultPrefabForVariant) {
                dispatch(applyPrefab(defaultPrefabForVariant));
            }
        }
        return;
    }

    const prefabsFitAllVariants = selectIfPrefabsFitAllVariants(state);
    if (!prefabsFitAllVariants) {
        const currentPrefab = selectActivePrefab(state);
        const activeVariantId = selectActiveVariantId(state);
        // Don't override if current prefab is valid for this variant
        if (currentPrefab && !currentPrefab.excludedFromVariants?.includes(activeVariantId)) {
            return;
        }

        const defaultPrefabForVariant = selectDefaultPrefabForActiveVariant(state);
        dispatch(applyPrefab(defaultPrefabForVariant));
    }
};

const selectDefaultPrefabForActiveVariant = createSelector([
    selectFilteredPrefabs,
    selectActiveVariantId
], (prefabs, activeVariantId) => {
    return prefabs.find(p => !p.excludedFromVariants?.includes(activeVariantId))!;
});